import { Col, Row } from 'antd'
import React from 'react'
import { CiSquarePlus } from 'react-icons/ci'
import { EllipsisOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Card, Dropdown, Menu } from "antd";

function StaffCustomer() {

    const menu = (
        <Menu>
            <Menu.Item key="1">Option 1</Menu.Item>
            <Menu.Item key="2">Option 2</Menu.Item>
        </Menu>
    );

    const cardData = [
        { title: 'Globex Shipping Line', Email: "accountant@example.com", Location: "Savannah, Georgia USA", },
        { title: 'Worldlog International', Email: "accountant@example.com", Location: "Savannah, Georgia USA", },
        { title: 'Globex Shipping Line', Email: "accountant@example.com", Location: "Savannah, Georgia USA", },
        { title: 'HLogistics', Email: "accountant@example.com", Location: "Savannah, Georgia USA", },

    ];

    return (
        <div>

            <Row gutter={24} style={{ border: "1px solid #D9D9D9", backgroundColor: "#FFFFFF", padding: "12px", borderRadius: "8px" }}>
                <Col span={12} style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    Manage Customer
                </Col>
                <Col span={12} style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}>
                    <CiSquarePlus size={30} style={{ cursor: "pointer" }} />
                </Col>
            </Row>

            <Row gutter={24} style={{ marginTop: "25px" }}>
                {cardData.map((data, index) => (
                    <Col span={6} style={{ marginTop: "25px" }}>
                        <Card
                            style={{
                                width: 250,
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                textAlign: "center",
                                position: "relative",
                            }}
                        >
                            {/* Top-right 3-dot icon */}
                            <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
                                <EllipsisOutlined
                                    style={{
                                        position: "absolute",
                                        top: 16,
                                        right: 16,
                                        fontSize: "18px",
                                        cursor: "pointer",
                                    }}
                                />
                            </Dropdown>

                            <div
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    marginBottom: "15px",
                                    marginRight: "auto",
                                    marginLeft: "auto",
                                }}
                            >
                                <img
                                    src="/images/empview.png"
                                    alt="User"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                    }}
                                />
                            </div>
                            {/* Roles */}
                            <div style={{ marginTop: 16, fontWeight: "bold", fontSize: "14px" }}>
                                {/* <UserOutlined style={{ marginRight: 8 }} /> */}
                                {data.title}
                            </div>
                            <div style={{
                                marginTop: 8,
                                width: "80%", // Reduced width
                                marginLeft: "auto",
                                marginRight: "auto",
                                border: "1px solid #ccc",
                                borderRadius: "12px",
                                fontSize: "12px",
                                backgroundColor: "#F2F2F2",
                                marginBottom: "12px"
                            }}>
                                {data.Email}
                            </div>

                            {/* Location */}
                            <div style={{ marginTop: 8, fontSize: "14px", color: "#555" }}>
                                <EnvironmentOutlined style={{ marginRight: 8 }} />
                                {data.Location}
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>


        </div>
    )
}

export default StaffCustomer
